"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function warn() {
  var _console;
  (_console = console).warn.apply(_console, arguments);
}
function error() {
  var _console2;
  (_console2 = console).error.apply(_console2, arguments);
}
function info() {
  var _console3;
  (_console3 = console).info.apply(_console3, arguments);
}
var logger = {
  warn: warn,
  error: error,
  info: info
};
var _default = exports["default"] = logger;